import { IconComponentProps } from './index'

const NavigationDigitalHub =  ({ width = 24, height = 24, customClass = '' }: IconComponentProps) => <svg width={width} height={height} viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg' className={`strokefill ${customClass}`}>
  <circle cx='12' cy='6' r='3' stroke='#5F6C7A' stroke-width='1.4'/>
  <path d='M18.9649 12.2946C18.827 10.9169 18.2897 9.65698 17.4705 8.63226' stroke='#5F6C7A' stroke-width='1.4' stroke-linecap='round'/>
  <path d='M6.6311 8.50812C5.77064 9.53548 5.19958 10.8135 5.04333 12.2167' stroke='#5F6C7A' stroke-width='1.4' stroke-linecap='round'/>
  <path d='M11.1349 19.9471C11.4184 19.982 11.7071 20 12 20C12.3044 20 12.6043 19.9806 12.8985 19.9429' stroke='#5F6C7A' stroke-width='1.4' stroke-linecap='round'/>
  <circle cx='18' cy='18' r='3' stroke='#5F6C7A' stroke-width='1.4'/>
  <circle cx='6' cy='18' r='3' stroke='#5F6C7A' stroke-width='1.4'/>
</svg>

export default NavigationDigitalHub